import { isAxiosError } from 'axios';
import { TURNSTILE_ERROR_CODES, TURNSTILE_HEADER } from '@capsico/contracts';

/** W25: the request header for a Turnstile token (nothing when there is no token). */
export function turnstileHeaders(token: string | null | undefined): Record<string, string> {
  return token ? { [TURNSTILE_HEADER]: token } : {};
}

/** Which Turnstile refusal a failed API call was, if any. */
export function turnstileErrorKind(error: unknown): 'required' | 'failed' | null {
  if (!isAxiosError(error)) return null;
  const body = error.response?.data as { error?: { code?: unknown } } | undefined;
  const code = body?.error?.code;
  if (code === TURNSTILE_ERROR_CODES.REQUIRED) return 'required';
  if (code === TURNSTILE_ERROR_CODES.FAILED) return 'failed';
  return null;
}
